/* import __COLOCATED_TEMPLATE__ from './row-actions.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'ember-intl/services/intl';
import type AppService from 'embercom/services/app-service';
import type Store from '@ember-data/store';
import type { KnowledgeHubTableRow } from 'embercom/models/content-service/knowledge-hub-content-wrapper';
import { EntityType } from 'embercom/models/data/entity-types';

interface Args {
  tableRow: KnowledgeHubTableRow;
  activeHoverRowId?: string | null;
}

export default class RowActions extends Component<Args> {
  @service declare intl: IntlService;
  @service declare store: Store;
  @service declare appService: AppService;
  @service declare notificationsService: any;
  @tracked isDropdownOpen = false;

  get isSyncableContent(): boolean {
    let tableRow = this.args.tableRow;
    let entityType = 'entityType' in tableRow ? tableRow.entityType : tableRow.contentType;
    return (
      entityType === EntityType.ExternalContent || entityType === EntityType.ContentImportRunRecord
    );
  }

  get shouldShowActions(): boolean {
    // Only show actions for syncable content when hovering over this specific row OR when dropdown is open
    return (
      this.isSyncableContent &&
      (this.args.activeHoverRowId === this.args.tableRow.id || this.isDropdownOpen)
    );
  }

  get actionOptions() {
    return [
      {
        items: [
          {
            text: this.intl.t('knowledge-hub.filterable-list.row-actions.resync'),
            icon: 'sync',
            isDisabled: false,
          },
          {
            text: this.intl.t('knowledge-hub.filterable-list.row-actions.exclude-from-sync'),
            icon: 'delete',
            isDisabled: true,
          },
        ],
      },
    ];
  }

  @action
  handleDropdownOpen(): void {
    this.isDropdownOpen = true;
  }

  @action
  handleDropdownClose(): void {
    this.isDropdownOpen = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::RowActions': typeof RowActions;
    'knowledge-hub/filterable-list/table/cells/row-actions': typeof RowActions;
  }
}
